var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React, { PureComponent } from 'react';
import moment from 'moment';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { generateUUID, trigger } from '@philips-internal/oswald-ui-utils';
import { eventListener } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { Card, Tag, Tooltip, TooltipTrigger } from '@philips-internal/oswald-ui-components';
import './card-suggestion-item.css';
import { array, number } from 'prop-types';
import { ParseHelperUtils } from '../../util/parse-helper-utils';
import { AppointmentUtils } from '../../util/appointment-utils';
import { LanguageService, MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { ClickEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { SelectionType } from '@philips-internal/oswald-ui-constants';
import { LocaleTypes } from '../../constants/locale-types';
let CardSuggestionItem = class CardSuggestionItem extends PureComponent {
    static { this.propTypes = {
        onClick: eventListener,
        suggestionId: number,
        suggestionItems: array,
    }; }
    render() {
        const { suggestionItems, onClick } = this.props;
        return (React.createElement("div", { onClick: trigger(onClick, new ClickEvent()) }, suggestionItems.map((suggestionItem, index) => {
            suggestionItem.price = suggestionItem.isShowPrice
                ?
                    AppointmentUtils.getPriceByAppointmentType(suggestionItem.price, suggestionItem.appointmentType, suggestionItem.shouldDisplayTheExamValue, suggestionItem.shouldDisplayTheConsultationValue)
                :
                    '';
            return this.renderItem(suggestionItem, index);
        })));
    }
    renderItem(item, index) {
        return (React.createElement(Card, { key: index, className: 'card-suggestion-item', width: 12, uuid: generateUUID(), selectionType: SelectionType.SINGLE }, this.renderText(item)));
    }
    renderTeleconsultationTag(teleconsultationType) {
        const typeSchedulePresential = 'N';
        const typeScheduleHybrid = 'H';
        if (teleconsultationType === typeSchedulePresential) {
            return (React.createElement(Tag, { value: MessageService.translate('text.in-person'), formatters: {} }));
        }
        if (teleconsultationType === typeScheduleHybrid) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Tag, { value: MessageService.translate('text.in-person'), formatters: {} }),
                React.createElement(Tag, { value: MessageService.translate('patient.teleconsultation'), formatters: {} })));
        }
        return (React.createElement(Tag, { value: MessageService.translate('patient.teleconsultation'), formatters: {} }));
    }
    renderText(suggestionItem) {
        if (suggestionItem.availableType === 'R') {
            return (React.createElement("div", { className: 'suggestion-item schedule-item' },
                React.createElement("div", { className: 'left' },
                    React.createElement("div", { className: 'title' }, suggestionItem.title),
                    React.createElement("div", { className: 'subtitle1' }, suggestionItem.subtitle1)),
                React.createElement("div", { className: 'right' },
                    React.createElement("div", { className: 'tag-list' },
                        this.renderTeleconsultationTag(suggestionItem.teleconsultationType),
                        React.createElement(Tooltip, { triggers: [TooltipTrigger.HOVER], value: MessageService.translate('patient.tooltip.request'), multiline: true },
                            React.createElement("div", { className: 'tooltip-custom__target' },
                                React.createElement(Tag, { value: MessageService.translate('patient.request'), formatters: {} })))),
                    React.createElement("span", { className: 'price-coseguro' },
                        this.showValueOrReturn(suggestionItem.price, suggestionItem.ieReturn),
                        this.showCopagoValue(suggestionItem.copagoPrice)))));
        }
        const time = suggestionItem.endDate ? moment(suggestionItem.startDate).format('HH:mm') + ' - ' + moment(suggestionItem.endDate).format('HH:mm') : moment(suggestionItem.startDate).format('HH:mm');
        return (React.createElement("div", { className: 'suggestion-item' },
            React.createElement("div", { className: 'left' },
                React.createElement("div", { className: 'title' },
                    suggestionItem.title,
                    " - ",
                    time,
                    "h"),
                React.createElement("div", { className: 'subtitle1' }, suggestionItem.subtitle1)),
            React.createElement("div", { className: 'right' },
                React.createElement("div", { className: 'tag-list' }, this.renderTeleconsultationTag(suggestionItem.teleconsultationType)),
                React.createElement("span", { className: 'price-coseguro' },
                    this.showValueOrReturn(suggestionItem.price, suggestionItem.ieReturn),
                    this.showCopagoValue(suggestionItem.copagoPrice)))));
    }
    showValueOrReturn(price, ieReturn) {
        if (ieReturn) {
            return (React.createElement("label", { className: 'return' }, MessageService.translate('patient.return')));
        }
        return (React.createElement("span", { className: 'price' }, price != '' &&
            React.createElement(React.Fragment, null,
                React.createElement("div", null, MessageService.translate('tws.appointment-suggestion.price')),
                React.createElement("div", null, ParseHelperUtils.parseToTextHtml(price)))));
    }
    showCopagoValue(copago) {
        const language = LanguageService.getCurrentLanguage();
        if (language === LocaleTypes.ARGENTINA) {
            return (React.createElement("span", { className: 'price' },
                React.createElement("div", null, MessageService.translate('tws.appointment-suggestion.copago')),
                React.createElement("div", null, ParseHelperUtils.parseToTextHtml(copago))));
        }
        return (React.createElement(React.Fragment, null));
    }
};
CardSuggestionItem = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY })
], CardSuggestionItem);
export default CardSuggestionItem;
//# sourceMappingURL=card-suggestion-item.js.map